import { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import ChatList from "../../components/chatlist/ChatList";
import Message from "../../components/message/Message";
import ProfileBox from "../../components/profilebox/ProfileBox";
import "./chatbox.css";
import { useParams} from "react-router-dom";
import ConversationService from "../../services/conversation.service";
import { AuthContext } from "../../context/AuthContext";

const useStyles = makeStyles((theme) => ({
	gridContainer: {
		width: "100%",
	},
	gridContent: {
		padding: "30px 60px",
	},
	profileContainer: {
		width: "80%",
		margin: "0px auto",
	},
	chatbox: {
		width: "100%",
		height: "100vh",
		padding: "10px",
		borderRadius: "6px",
		marginTop: "20px",
		fontSize: "20px",
		textAlign: "center",
		color: "white",
		backgroundColor: "#901919",
	},
	username: {
		fontWeight: "bold",
		textAlign: "center",
	},
	profileBox: {
		border: "1px solid rgba(144, 25, 25, 0.02)",
		boxShadow: "0px 4px 4px rgba(144, 25, 25, 0.05)",
		padding: "10px",
	},
	profileBoxText: {
		fontWeight: "600",
		margin: "20px",
	},
	chats: {
		position: "relative",
		width: "100%",
	},
}));

const Chatbox = () => {
	const { user } = useContext(AuthContext);
	const { receiverId } = useParams();
	const classes = useStyles();
	const [chatList, setChatList] = useState([]);
	const [currentChat, setCurrentChat] = useState(null);
	const [receiver, setReceiver] = useState(null);

	useEffect(() => {
		if (receiverId) {
			setReceiver(receiverId);
		}
	}, [receiverId]);

	useEffect(() => {
		const controller = new AbortController();
		const signal = controller.signal;

		(async () => {
			const res = await ConversationService.getUserConversations(signal);
			setChatList(res.conversation);
		})();
		
		return () => controller.abort();
	}, []);

	return (
		<>
			<div className={classes.gridContainer}>
				<div className={classes.gridContent}>
					<Grid container>
						<Grid item xs={3}>
							<ProfileBox />
						</Grid>

						<Grid item xs={4}>
							<ChatList
								currentUser={user}
								conversations={chatList}
								currentChat={currentChat}
								setCurrentChat={setCurrentChat}
							/>
						</Grid>

						<Grid item xs={5} className={classes.chats}>
							<Message
								currentUser={user}
								receiver={receiver}
								setReceiver={setReceiver}
								currentChat={currentChat}
							/>
						</Grid>
					</Grid>
				</div>
			</div>
		</>
	);
};

export default Chatbox;
